<template>
  <div>
    <base-header class="pb-6">
      <b-row class="align-items-center py-4">
        <b-col cols="12" class="d-flex align-items-center">
          <base-button
            v-if="viewMode == 'edit'"
            type="danger"
            class="mr-3"
            @click="cancel"
          >
            Back
          </base-button>
          <h6 class="h2 text-white d-inline-block mb-0">{{ $route.name }}</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-breadcrumb />
          </nav>
        </b-col>
      </b-row>
    </base-header>
    <div class="container-fluid mt--6">
      <b-card no-body class="mb-4">
        <!-- Card body -->
        <b-card-body>
          <b-card no-body>
            <div v-if="viewMode == 'list'">
              <el-table
                class="table-responsive table-flush"
                header-row-class-name="thead-light"
                row-key="content_template_id"
                :data="contentTemplates"
              >
                <el-table-column
                  type="selection"
                  align="left"
                  min-width="120px"
                >
                </el-table-column>

                <el-table-column
                  label="Template ID"
                  min-width="220px"
                  prop="content_template_id"
                  sortable
                >
                  <template v-slot="{ row }">
                    <b>{{ row.content_template_id }}</b>
                  </template>
                </el-table-column>
                <el-table-column
                  min-width="180px"
                  align="right"
                  label="Actions"
                >
                  <div slot-scope="{ $index, row }" class="d-flex">
                    <base-button
                      @click.native="handleEdit($index, row)"
                      class="edit"
                      type="success"
                      size="sm"
                      icon
                    >
                      <i class="text-white ni ni-ruler-pencil"></i>
                    </base-button>
                  </div>
                </el-table-column>
              </el-table>
            </div>

            <div class="editorContainer" v-if="viewMode == 'edit'">
              <div class="editorFrame">
                <b-card-body>
                  <b-row>
                    <b-col md="12">
                      <base-input
                        name="Content Template Id"
                        label="Content Template Id"
                        v-model="currentItem.content_template_id"
                        disabled
                      />
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="12">
                      <base-input
                        name="Content Template Name"
                        label="Content Template Name"
                        v-model="currentItem.content_template_name"
                      />
                    </b-col>
                  </b-row>
                </b-card-body>
                <div style="margin-left: 40px;margin-right: 40px;">
                  <email-template-tip-tap-editor
                    v-model="html"
                    class="content-template-editor"
                  />

                  <div style="text-align:center;">
                    <base-button @click="saveItem()" type="primary" class="mb-4"
                      >Save Template</base-button
                    >

                    <base-button
                      @click="cancel()"
                      type="secondary"
                      class="mb-4 btn-outline-primary"
                      >Cancel</base-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </b-card>
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>

<script>
import { GlobalStore } from "../../globalStore";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip
} from "element-ui";
import { appFunctions } from "../../helpers/appFunctions";
import EmailTemplateTipTapEditor from "../../components/admin/EmailTemplateTipTapEditor.vue";

export default {
  name: "ContentTemplates",
  components: {
    EmailTemplateTipTapEditor,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu
  },
  data() {
    return {
      realmApp: null,
      contentTemplates: [],
      viewMode: "list",
      currentItem: {},
      html: ""
    };
  },
  methods: {
    cancel() {
      this.viewMode = "list";
    },
    saveItem() {
      this.currentItem.content_template_html = this.html;
      this.contentTemplates = appFunctions
        .crud_contentTemplate("update", this.currentItem)
        .then(resp => {
          console.log(resp);
          this.getContentTemplates();
          this.viewMode = "list";
        });
    },
    editItem(id) {
      this.viewMode = "edit";
      this.currentItem = this.contentTemplates.find(
        f => f.content_template_id === id
      );
      this.html = this.currentItem.content_template_html || "";
      console.log(this.currentItem);
    },
    getContentTemplates() {
      this.contentTemplates = appFunctions
        .crud_contentTemplate("list")
        .then(resp => {
          this.contentTemplates = resp.data;
        });
    },
    handleEdit(index, row) {
      console.log(index, row);
      this.editItem(row.content_template_id);
    }
  },
  async mounted() {
    this.realmApp = GlobalStore.realmApp;
    this.getContentTemplates();
  }
};
</script>

<style lang="scss">
.contentTemplateList {
  table {
    margin: auto;
    width: 800px;
  }
  td {
    padding: 10px;
    text-align: left;
  }

  .editor__content {
    height: 400px;
    border: 1px solid lightgray;
    overflow-y: auto;
    text-align: left;
  }

  .editorFrame {
    width: 930px;
    margin: auto;
  }

  .field-layout {
    text-align: left;
    padding: 10px;
    position: relative;
    &__col1 {
      width: 200px;
      display: inline-block;
    }
    &__col2 {
      display: inline-block;
      input {
        width: 400px;
      }
    }
  }
}

.content-template-editor {
  min-height: 300px;
}
</style>
